import { render, staticRenderFns } from "./WithdrawalReceiptModal.vue?vue&type=template&id=df25fd4a&scoped=true"
import script from "./WithdrawalReceiptModal.vue?vue&type=script&lang=js"
export * from "./WithdrawalReceiptModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalReceiptModal.vue?vue&type=style&index=0&id=df25fd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df25fd4a",
  null
  
)

export default component.exports